import { SubscriptionPlan } from 'api3';
import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import { PaymentService } from '@app/services/payment.service';
import { TranslocoPipe } from '@jsverse/transloco';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-trial-end-banner',
  imports: [TranslocoPipe, RouterLink, Button],
  standalone: true,
  template: `
    @if (hasTrial() && trialLeftDays() > 0 && trialLeftDays() <= 5) {
      <div class="flex items-center justify-center gap-3 bg-blue-700 p-2 text-white">
        @if (isAdmin()) {
          <p
            class="text-center [&_span]:max-md:hidden"
            [innerHTML]="
              'profile.subscription.banner.text'
                | transloco
                  : {
                      daysLeft:
                        '<strong>' +
                        (trialLeftDays() === 1
                          ? ('profile.subscription.banner.daysLeftSingular' | transloco)
                          : ('profile.subscription.banner.daysLeftPlural' | transloco: { count: trialLeftDays() })) +
                        '</strong>',
                      optionalText: '<span>' + ('profile.subscription.banner.optionalText' | transloco) + '</span>',
                    }
            "></p>
          <p-button [routerLink]="'/profile/me'" size="small" severity="secondary" class="![&>button]:py-0">
            <span
              class="whitespace-nowrap text-center text-sm [&_span]:max-md:hidden"
              [innerHTML]="
                'profile.subscription.banner.button'
                  | transloco
                    : {
                        optionalButtonText: '<span>' + ('profile.subscription.banner.optionalButtonText' | transloco) + '</span>',
                      }
              "></span>
          </p-button>
        } @else {
          <p
            class="text-center [&_span]:max-md:hidden"
            [innerHTML]="
              'profile.subscription.banner.deviceUser.text'
                | transloco
                  : {
                      daysLeft:
                        '<strong>' +
                        (trialLeftDays() === 1
                          ? ('profile.subscription.banner.daysLeftSingular' | transloco)
                          : ('profile.subscription.banner.daysLeftPlural' | transloco: { count: trialLeftDays() })) +
                        '</strong>',
                    }
            "></p>
        }
      </div>
    }
  `,
})
export class TrialEndBannerComponent {
  authService = inject(AuthService);
  paymentService = inject(PaymentService);

  isAdmin = computed(() => this.authService.currentUser()?.qiraRole === 'ADMIN');
  trialLeftDays = computed(() => this.paymentService.trialLeftDays() ?? 0);
  hasTrial = computed(() => this.authService.currentUser()?.subscription?.plan === SubscriptionPlan.Trial);
}
